var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"headerbrand"},[_c('h3',[_vm._v("Presentado por"),_c('img',{staticClass:"logo",attrs:{"src":_vm.brand.image,"alt":_vm.brand.title}})])])}
var staticRenderFns = []

export { render, staticRenderFns }